<div class="container-fluid">
  <div class="card border-light shadow-sm">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
          <i class="fa fa-pencil-square-o"></i>
          <b>Motivation </b> <span style="color:lightgray"><a class="red-asterik"> *</a> Please motivate the need for the particular service(s)</span>
        </h6>
      </div>
    </div> 
    <form [formGroup]="form">
      <div class="col-md-12 p-0">
        <div class="col-sm-12 p-0">
          <label for="description"> Please motivate the need for the particular service(s)<span style="color:lightgray"> <a class="red-asterik"> *</a> At least 20 characters required</span></label>
          <!--<textarea [(ngModel)]="model.application.motivation_detail" formControlName="motivation" (click)="changes()" style="min-width: 100%">
              </textarea>-->

          <ckeditor formControlName="motivation" debounce="500" [readonly]="!isProcess || (isDuplicate)" [(ngModel)]="model.application.motivation_detail">
          </ckeditor>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="col-12" *ngIf="isProcess || dataCntrl.status == '2'">
  <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2" [disabled]="disableBtn" (click)="backToTab()"
          title="Back" style="float: left !important;">
    Back
  </button>
  <ng-container *ngIf="isProcess || dataCntrl.status == '2'">
  <button class="btn btn-md m-clr pull-right hd-btn mt-2" [disabled]="disableBtn" (click)="cancelApplication()" title="Cancel" style="float: right !important;">Cancel</button>
  <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
          (click)="saveMotivation()" title="Save & Continueto step 5" [disabled]="disableBtn" style="float: right !important;">
     Save & Continue
  </button>
  </ng-container>
  <div *ngIf="disableBtn">
    <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
            routerLink="/permit/approval" title="Cancel" style="float: right !important;">
      <i class="fa fa-times"></i> Back
    </button>
  </div>
</div>
  <div class="col-12" *ngIf="pageload">
    <app-busy [message]="message"></app-busy>
  </div>
